import script from "./ShapeInputFieldsWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeInputFieldsWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ShapeInputFieldsWrapper.vue?vue&type=style&index=0&id=94f2bb5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94f2bb5a"]])

export default __exports__